import { FC, ImgHTMLAttributes } from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore FIXME: can't find module even though it is in d.ts
import EmptyImage from './assets/empty.gif';

const ImageEmpty: FC<ImgHTMLAttributes<HTMLImageElement>> = (props) => {
  return <img src={EmptyImage} alt="" style={{ maxWidth: '100%', maxHeight: '100%' }} {...props} />;
};

export default ImageEmpty;
